import { createGqlQuery } from '../fetcher';
import { Forms } from '../queries/forms.query';
import type * as Types from '../types';

export const useFormsQuery = createGqlQuery<Types.FormsQueryVariables, Types.FormsQuery>(
  (variables) => ['forms', variables],
  Forms,
);
